'use client'

import { useState } from 'react'
import { cn, formatPrice } from '@/lib/utils'

import { Input, ScrollArea } from '@/components/ui'

interface ReportStockViewProps {
  items: any[]
}

export const ReportStockView = ({ items }: ReportStockViewProps) => {
  const [searchQuery, setSearchQuery] = useState('')

  const filteredItems = items?.filter((item) =>
    item?.product_name?.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  return (
    <div className="flex h-full w-full flex-col overflow-hidden rounded-lg border border-gray-100 bg-white shadow-card">
      <div className="sticky top-0 flex flex-col gap-4 border-b border-gray-100 bg-white">
        <div className="grid w-full grid-cols-[3fr,1fr,1fr,1.5fr,1.5fr,1.5fr,1.5fr] items-center overflow-hidden rounded-t-lg bg-gray-50 text-sm font-medium [&>span:last-of-type]:border-r-0 [&>span]:flex [&>span]:h-full [&>span]:w-full [&>span]:items-center [&>span]:justify-end [&>span]:border-r [&>span]:border-gray-100 [&>span]:px-4 [&>span]:py-3">
          <span className="flex items-center !justify-start gap-2">
            <span className="text-left">Product</span>
            <Input
              placeholder="Filter by Name"
              value={searchQuery}
              onChangeValue={(value) => setSearchQuery(value)}
              className="h-8 w-[200px] rounded-md px-2"
            />
          </span>
          <span className="text-right">Sold Qty</span>
          <span className="text-right">Addons Qty</span>
          <span className="text-right">Inventory Qty</span>
          <span className="text-right">Return Qty</span>
          <span className="text-right">Available Qty</span>
          <span className="text-right">Total Sold Amount</span>
        </div>
      </div>

      <ScrollArea className="flex h-full w-full flex-col gap-12">
        <div className="grid w-full bg-white">
          {filteredItems?.map((item) => {
            return (
              <div
                className={cn(
                  'grid w-full grid-cols-[3fr,1fr,1fr,1.5fr,1.5fr,1.5fr,1.5fr] items-center border-b border-gray-100 bg-white text-sm font-medium hover:bg-gray-50 [&>span:last-of-type]:border-r-0 [&>span]:flex [&>span]:h-full [&>span]:w-full [&>span]:items-center [&>span]:justify-end [&>span]:border-r [&>span]:border-gray-100 [&>span]:px-4 [&>span]:py-3',
                  'last:border-b-0',
                )}
                key={item?.product_name + item?.variant_id}
              >
                <span className="!justify-start text-left">
                  {item?.product_name}
                </span>
                <span className="text-right">
                  {item?.total_item_sold_qty?.toLocaleString()}
                </span>
                <span className="text-right">
                  {item?.total_addons_sold_qty?.toLocaleString()}
                </span>
                <span className="text-right">
                  {item?.total_inventory_qty?.toLocaleString()}
                </span>
                <span className="text-right">
                  {item?.total_return_qty?.toLocaleString()}
                </span>
                <span className="text-right">
                  {item?.total_available_qty?.toLocaleString()}
                </span>
                <span className="text-right">
                  {formatPrice(item?.total_item_sold_price)}
                </span>
              </div>
            )
          })}
        </div>
      </ScrollArea>
    </div>
  )
}
